<template>
  <div class="content">
    <div class="search-area"  v-if="dataList != null && dataList.length > 0"> 
    <!-- {{dataList}} -->
         <h3 class="t-left" style="margin: 0;margin-bottom: 10px;">计算的参数值</h3>
         <div v-for="da in dataList" class="t-left" style="margin-top: 5px;">{{da}}</div>
    </div>
    <div class="search-area mt15 t-left"  v-if="repositoryDescription != null && repositoryDescription != ''"> 
    <!-- {{dataList}} -->
         <h3 class="t-left" style="margin: 0;margin-bottom: 10px;">算法名词解释</h3>
         {{repositoryDescription}}
         <!-- <div v-for="da in dataList" class="t-left" style="margin-top: 5px;">{{da}}</div> -->
    </div>
    <!-- <div class="button-area">
      <el-button icon="el-icon-plus" size="medium" type="info" @click="add(1, '')">添加岗位</el-button>
      <el-button size="medium" type="danger" @click="getDeleteData(1, '')">批量删除</el-button> 
    </div> -->
    <!-- <div class="button-area">
      <el-button icon="el-icon-s-data" size="medium" type="info" @click="classify">按省汇总</el-button>
    </div> -->
    <div class="back-color-fff p16 mt15" style="display: flex;">  
      <div class="echarts w70f fl" id="pie" :style="height"></div> 
       <el-table
      :data="tableData"
      border
      style="width: 25%;float: left;margin-left: 2%;">
      <el-table-column
        prop="periodTag"
        label="预测周期"
        align="center">
      </el-table-column>
      <el-table-column
        prop="salesLowerBound"
        label="预测下限(件)"
        align="right"  header-align="center">
        <template slot-scope="scope">{{ scope.row.salesLowerBound}}</template>
      </el-table-column>
      <el-table-column
        prop="sales"
        label="预测销售量(件)"
        align="right" header-align="center" width="130">
        <template slot-scope="scope">{{ scope.row.sales}}</template>
      </el-table-column>
      <el-table-column
        prop="salesUpperBound"
        label="预测上限(件)"
        align="right"  header-align="center">
        <template slot-scope="scope">{{ scope.row.salesUpperBound}}</template>
      </el-table-column>
    </el-table>
  </div>
  </div>
</template>

<script>
import areaJson from '../../assets/js/china_address_v4.js';
export default {
  data() {
    return {
      // options: areaJson,
      options:[{
          label:'无限制',
          value:'1'
      }],
      wxzList: [{
          value: '1',
          label: '无限制'
        }],
      wxz:'1',
      month:'',
      page: {
        pageIndex: 1,
        pageSize: 1000,
        totalPage: 0,
        totalRows: 0,
        goodsGuids: '',
        startMonth: '',
        endMonth: '',
      },
      winHeight: window.innerHeight,
      height: {
        height: '',
      },
      dialogTableVisible: false,
      tableData: [],
      classifyList: [],
      timeList: '',
      timeListS: '',
      customerCount: 0,
      franchiseeCount: 0,
      sumAmount: 0,
      totalGoodsSpecNum: 0,
      loading:false,
      goodsData:[],
      repositoryDescription:'',
      dataList:[],
      history:[],
    };
  },
  created() {
    let self = this;  
    let list = '';
    let canList = [];
     if(self.$router.history.current.query.list != null){
          list = JSON.parse(self.$router.history.current.query.list);   
          for(let i in list){ 
            let z = i +'：'+ list[i]
            canList.push(z); 
          }
    }
    if(self.$router.history.current.query.repositoryDescription != null){
          self.repositoryDescription = JSON.parse(self.$router.history.current.query.repositoryDescription);    
    }  
    self.dataList = canList;
    // 列表 
    self.getData(true);
    // self.getGoodsForecast();
  },
    mounted(){     
    window.onresize = () => { 
    return (() => { 
    this.winHeight = window.innerHeight 
        })
    } 
    this.height.height=this.winHeight-440+'px';
  }, 
  methods: {
    empty() {
      let self = this;
      self.timeList = '';
      self.timeListS = '';
      self.page = {
        pageIndex: 1,
        pageSize: 1000,
        totalPage: 0,
        totalRows: 0,
        goodsGuids: '',
        startMonth: '',
        endMonth: '',
      };
      self.getData(true);
    },
    getGoodsForecast() {
      let self = this; 
      self.api.postJson(`/${serverConfig.msAiAlgorithmService}/goods/data/get`,{'pageIndex':1,'pageSize':1000}).then(res => {
        if (res.data.code == serverConfig.REQUIRE_SUCCESS_CODE) {
          self.goodsData = res.data.data.records;  
        } else {
          self.$message.error(res.data.msg);
        }
      });
    },
    getData(flg) {
      let self = this;
      self.loading = true;    
      self.api.postJson(`/${serverConfig.msAiAlgorithmService}/goods-forecast/data/get-chart`,{'mathConditionGuid':self.$router.history.current.query.guid}).then((res) => {
        if (res.data.code == serverConfig.REQUIRE_SUCCESS_CODE) {
          self.loading = false; 
          // let list = [];
          // if(res.data.data != null){
          //       Object.getOwnPropertyNames(res.data.data).forEach(function(key) {
          //         let o = {
          //           k: key,
          //           v: res.data.data[key]
          //         }
          //         list.push(o)
          //       })
          // }  
          // if(list != null){
          //   list[2].n = [];
          //   list[2].v.forEach(function(i){
          //        list[2].n.push(i.substr(4,5)); 
          //   })
          //   console.log(list);
            self.tableData = res.data.data.tableVOS;
            // res.data.data.history.forEach(function(i){
            //       if(i==0){
            //           i = 'undefined'
            //       }else{
            //           i = self.numDigit(i)
            //       }
            //       self.history.push(i);
            // })
            self.myChart(res.data.data);
        } else {
          self.$message.error(res.data.msg);
        }
      });
    }, 

    myChart(data) {
      let self = this;
      let myChart = self.$echarts.init(document.getElementById('pie'));
      let option = {
      title: {
          text: '销售预测'
      },
      tooltip: {
          trigger: 'axis'
      },
      legend: {
          data: ['销售数据', '预测销售数据']
      },
      grid: {
          left: '3%',
          right: '4%',
          bottom: '3%',
          containLabel: true
      },
      toolbox: {
          feature: {
              saveAsImage: {}
          }
      },
      xAxis: {
          type: 'category',
          boundaryGap: false, 
          data: data.xAxis
      },
      yAxis: {
          type: 'value',
      },
      series: [
          {
              name: '销售件数',
              type: 'line', 
              data: data.history
          },
          {
              name: '趋势预测(销售件数)',
              type: 'line', 
              data: data.forecast
          },
          {
              name: '置信下限(销售件数)',
              type: 'line', 
              data: data.lowerBound
          },
          {
              name: '置信上限(销售件数)',
              type: 'line', 
              data: data.upperBound
          },
      ]
  };
      myChart.setOption(option);
    }, 
    
    handleSizeChange(val) {
      let self = this;
      self.page.pageSize = val;
      this.getData();
    },
    handleCurrentChange(val) {
      let self = this;
      self.page.pageIndex = val;
      this.getData();
    },
  },
};
</script>
</script>
<style scoped>
.el-range-editor.el-input__inner {
  padding: 0px;
}
.w70f {
  width: 70%;
}
</style>